import React, { HTMLProps, useContext, useEffect, useState } from 'react';
import { ComparisonScreenFundSelectionContext } from '../ComparisonScreen';

export const SwipableSection: React.FC<
    {
        pages?: React.ReactNode[];
    } & HTMLProps<HTMLDivElement>
> = ({
    pages = [
        <div className="flex justify-center h-20 bg-bnd-yellow rounded-lg">Bond 1</div>,
        <div className="flex justify-center h-20 bg-blue-500 rounded-lg">Bond 2</div>,
        <div className="flex justify-center h-20 bg-bnd-pink rounded-lg">Bond 3</div>,
    ],
    className,
}) => {
    const [swipeStart, setSwipeStart] = useState({ x: 0, y: 0 });
    const [swipeEnd, setSwipeEnd] = useState({ x: 0, y: 0 });

    const comparisonContext = useContext(ComparisonScreenFundSelectionContext);

    useEffect(() => {
        comparisonContext.onSwipe({ x: swipeStart.x - swipeEnd.x, y: swipeStart.y - swipeEnd.y });
    }, [swipeEnd]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className={`relative w-full rounded-lg flex flex-1 flex-col ${className}`}>
                {pages.map((page, index) => {
                    return (
                        <div
                            className={`${
                                index !== 0 ? 'absolute' : ''
                            } w-full h-full rounded-lg transition duration-700 transform ${
                                index < comparisonContext.selectedFundIndex
                                    ? '-translate-x-full opacity-0'
                                    : index > comparisonContext.selectedFundIndex
                                    ? 'translate-x-full opacity-0'
                                    : ''
                            }`}
                            onTouchStart={(e) => {
                                setSwipeStart({
                                    x: +e.nativeEvent.touches[0].pageX.toFixed(2),
                                    y: +e.nativeEvent.touches[0].pageY.toFixed(2),
                                });
                            }}
                            onTouchEnd={(e) => {
                                setSwipeEnd({
                                    x: +e.nativeEvent.changedTouches[0].pageX.toFixed(2),
                                    y: +e.nativeEvent.changedTouches[0].pageY.toFixed(2),
                                });
                            }}
                            key={index}
                        >
                            {page}
                        </div>
                    );
                })}
            </div>
        </>
    );
};
